import {GetCategory,SearchCategory,GetCategoryUrl} from '@/api/Evaluate'

const Evaluate = {
  state: {

  },
  mutations: {

  },
  actions: {
    getCategory({commit},params){
      return new Promise((resolve, reject) => {
        GetCategory(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    searchCategory({commit},params){
      return new Promise((resolve, reject) => {
        SearchCategory(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCategoryUrl({commit},id){
      return new Promise((resolve, reject) => {
        GetCategoryUrl(id).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default Evaluate



// WEBPACK FOOTER //
// ./src/store/modules/Evaluate.js


// WEBPACK FOOTER //
// ./src/store/modules/Evaluate.js